import React from 'react';
import '../../styles/onboardingFlow/onboarding/onboardingMain.scss';
import OnboardingBusinessType from './OnboardingBusinessType';

interface OnboardingMainProps {
  currentStep: number;
  onStepChange?: (stepNumber: number) => void;
}

// Streamlined onboarding: the only step is the account-type screen. The former
// steps 2 (add client), 3 (install plugin / connect Claude), 4 (integrations)
// and 5 (first prompt) were removed from the flow — their components remain in
// the codebase but are no longer rendered here. All "connect" work now happens
// in-app via the dashboard checklist. Any step number is clamped to the single
// terminal screen so old/returning users never hit a blank wizard.
const OnboardingMain: React.FC<OnboardingMainProps> = ({ currentStep }) => {
  return (
    <div className='onboardingMain'>
      <OnboardingBusinessType />
    </div>
  );
};

export default OnboardingMain;
